module.exports = __webpack_public_path__ + "img/bg-modal-notifcation.aac0a67b.svg";